import { createReducer } from "redux-create-reducer";

import {
  GET_ORGANIZATION_INFO,
  UPDATE_ORGANIZATION_INFO,
  GET_ORGANIZATION_LOGIN,
  UPDATE_ORGANIZATION_LOGIN,
  CLEAR_ORGANIZATION_INFO,
} from "../types";

const initialState = {
  data: {},
  isLoading: true,
  isLoadingUpdate: false,
};

const organizationInfoReducer = createReducer(initialState, {
  [UPDATE_ORGANIZATION_LOGIN.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_ORGANIZATION_LOGIN.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_ORGANIZATION_LOGIN.FULFILLED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [UPDATE_ORGANIZATION_INFO.DEFAULT]: (state) => ({
    ...state,
    isLoadingUpdate: true,
  }),
  [UPDATE_ORGANIZATION_INFO.PENDING]: (state) => ({
    ...state,
    isLoadingUpdate: true,
  }),
  [UPDATE_ORGANIZATION_INFO.FULFILLED]: (state) => ({
    ...state,
    isLoadingUpdate: false,
  }),
  [UPDATE_ORGANIZATION_INFO.REJECTED]: (state) => ({
    ...state,
    isLoadingUpdate: false,
  }),
  [GET_ORGANIZATION_INFO.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORGANIZATION_INFO.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORGANIZATION_INFO.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_ORGANIZATION_INFO.FULFILLED]: (state, { payload }) => {
    return {
      ...state,
      data: payload.data,
      isLoading: false,
      isLoadingUpdate: false,
    };
  },
  [GET_ORGANIZATION_LOGIN.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORGANIZATION_LOGIN.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_ORGANIZATION_LOGIN.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_ORGANIZATION_LOGIN.FULFILLED]: (state, { payload }) => {
    return {
      ...state,
      login: payload.data,
      isLoading: false,
    };
  },
  [CLEAR_ORGANIZATION_INFO]: () => initialState,
});

export default organizationInfoReducer;



// WEBPACK FOOTER //
// ./src/features/organization/reducers/organizationInfoReducer.js